<template>
  <div class="devOps_reporterSpace">
    <!-- <el-tabs v-model="setType" type="card" style="width:100%;" @tab-click="handleClick" v-if="is_all_auth">
      <el-tab-pane label="人员"  name="Config" lazy v-if="menu.tab_user_page">
        <keep-alive>
          <component is="Config"></component>
        </keep-alive>
      </el-tab-pane>
      <el-tab-pane label="角色"  name="Role" lazy v-if="menu.tab_role_page">
        <keep-alive>
          <component is="Role"></component>
        </keep-alive>
      </el-tab-pane>
      <el-tab-pane label="团队"  name="Team" lazy v-if="menu.tab_team_page">
        <keep-alive>
          <component is="Team"></component>
        </keep-alive>
      </el-tab-pane>
      <el-tab-pane label="体系"  name="System" lazy v-if="menu.tab_project_system_page">
        <keep-alive>
          <component is="System"></component>
        </keep-alive>
      </el-tab-pane>
      <el-tab-pane label="菜单"  name="Menu" lazy v-if="menu.tab_menu_page">
        <keep-alive>
          <Menu is="Menu"></Menu>
        </keep-alive>
      </el-tab-pane>
    </el-tabs>
    <div v-else>暂无权限</div> -->
    <component :is="setType"></component>
  </div>
</template>
<script>
import {
  Department,
  Config,
  Role,
  Team,
  System,
  Menu,
} from './components/index.js'
import {mapState} from "vuex";
import {getDevOpsSpaceMenuListListApi} from "@/server/tops/base";
export default {
  name: "devOpsSettingSpace",
  components: {
    Department,
    Config,
    Role,
    Team,
    System,
    Menu
  },
  computed: {
    ...mapState(
        {
          allMenuList: (state) => state.devOps.ALLMENULIST,
        }
    ),
  },
  data() {
    return {
      setType: 'Menu',
      is_all_auth: 1,
      menu:{},
    };
  },
  async created() {
    await this.$store.dispatch('getDevopsMenuList',{})
    await this.$store.dispatch('getDevopsSelect')
  },
  methods: {
    async getAuth() {
      let menu = {}
      await getDevOpsSpaceMenuListListApi().then((res) => {
        res.data.forEach((item) => {
          item.map(item2 => {
            menu[item2] = 1;
          })
        })
      })
      this.menu = menu;
      if (!this.menu.tab_user_page && !this.menu.tab_role_page && !this.menu.tab_team_page && !this.menu.tab_project_system_page) {
        this.is_all_auth = 0;
      }
      if (this.menu.tab_menu_page) this.setType = 'Menu'
      if (this.menu.tab_project_system_page) this.setType = 'System'
      if (this.menu.tab_team_page) this.setType = 'Team'
      if (this.menu.tab_role_page) this.setType = 'Role'
      if (this.menu.tab_user_page) this.setType = 'Config'

    },
  },
};
</script>
<style lang="scss">
.devOps_reporterSpace {
  padding-top: 0px;
  // height: 70vh;
  // overflow: hidden;

  .reporter_type {
    font-size: 14px;
    font-weight: bold;
    color: #606266;
  }

  #tab-daily {
    padding-left: 20px;
  }

  .el-table {
    margin: 0;
  }

  /* #region 滚动条部分 */
  .el-table__body-wrapper {
    scrollbar-width: thin;
    scrollbar-color: skyblue #eee;
  }

  .el-table__body-wrapper::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 10px;
  }

  .el-table__body-wrapper::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    background-color: skyblue;
    background-image: -webkit-linear-gradient(45deg,
        rgba(255, 255, 255, 0.2) 25%,
        transparent 25%,
        transparent 50%,
        rgba(255, 255, 255, 0.2) 50%,
        rgba(255, 255, 255, 0.2) 75%,
        transparent 75%,
        transparent);
  }

  .el-table__body-wrapper::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #ededed;
    border-radius: 10px;
  }

  .el-select {
    width: 200px;
  }
}

.developing_model_dialog_child {
  .el-dialog__body {
    padding: 0 20px 10px;
  }
}
.el-tabs__item.is-active {
  background-color: #409EFF;
  color: #fff;
}

.el-tabs__item {
  width:65px;
  text-align: center;
  padding-left: 0 !important;
  padding-right: 0 !important;
  padding-bottom: 0;
  padding-top: 0;
  font-size: 12px;
  font-weight: bold;
  height: 30px;
  line-height: 30px;

}
.el-tabs__header {
  margin: 0 0 0 0 !important; ;
}
</style>
